import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ItemService from "../../services/ItemsServices";
import ItemCategoryService from "../../services/ItemCategoryService";
import ProjectCategoryService from "../../services/ProjectCategoryService";
import UomService from "../../services/UomService";
import Breadcrumb from "../../components/Breadcrumb";
import StorageService from "../../services/StorageService";
import { useParams } from "react-router-dom";
import MessageDialog from "../../components/MessageDialog";

export default function AddItem() {
  const [itemCategories, setItemCategories] = useState([]);
  const [projectCategories, setProjectCategories] = useState([]);
  const [uoms, setUoms] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  // const messageTimer = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const [dataLoaded, setDataLoaded] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    // formState: { errors },
  } = useForm();

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        // Fetch using ACTIVE APIs
        const [categoriesRes, uomsRes] = await Promise.all([
          ItemCategoryService.getActive(),
          UomService.getActive(),
        ]);

        // Set dropdown values directly
        setItemCategories(categoriesRes || []);
        setUoms(uomsRes || []);

      } catch (err) {
        console.error("Error fetching dropdowns:", err);
      }
    };

    fetchDropdowns();
  }, [setValue]);

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  const onSubmit = async (data) => {
    setLoading(true);
    console.log(data);

    try {
      const allItems = await ItemService.getAllItems();
      // const isDuplicate = allItems.some(
      //   (i) =>
      //     i.itemCode?.toLowerCase() === data.itemCode?.toLowerCase() &&
      //     // i.itemName?.toLowerCase() === data.itemName?.toLowerCase() &&
      //     i.itemCategory === data.itemCategoryId &&
      //     (!isEdit || i.id !== editId)
      // );

      // if (isDuplicate) {
      //   showMessage("Duplicate item exists", "error");
      //   setLoading(false);
      //   return;
      // }

      if (isEdit && editId) {
        data.updatedBy = StorageService.loginData().employeeId;
        await ItemService.updateItem(editId, data);
        showMessage("Item updated successfully", "success");
      } else {
        data.createdBy = StorageService.loginData().employeeId;
        await ItemService.saveItem(data);
        showMessage("Item added successfully", "success");
      }

      setTimeout(
        () => navigate("/cpnl/items/view", { state: { refresh: true } }),
        1000
      );
    } catch (err) {
      console.error("Error saving item:", err);

      const backendMsg =
        err?.response?.data?.message || err?.message || "Error saving item";

      showMessage(backendMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  // Load item details in modify mode
  // useEffect(() => {
  //   if (!id) return; // Add mode

  //   setIsEdit(true);
  //   setEditId(id);

  //   const fetchItemById = async () => {
  //     setEditLoading(true); // 🔄 start loading
  //     try {
  //       const res = await ItemService.getItemById(id);
  //       const record = res?.data || res;

  //       if (!record) {
  //         showMessage("Failed to load item details", "error");
  //         return;
  //       }

  //       setEditMode(true);

  //       // Prefill form
  //       setValue("itemCode", record.itemCode || "");
  //       // setValue("itemName", record.itemName || "");
  //       setValue("itemDescription", record.itemDescription || "");
  //       setValue("itemCategoryId", record.itemCategoryId || "");
  //       setValue("uomId", record.uomId || "");
  //     } catch (error) {
  //       console.error("Error fetching item:", error);
  //       showMessage("Error fetching item details", "error");
  //     } finally {
  //       setEditLoading(false); // ✅ stop loading
  //     }
  //   };

  //   fetchItemById();
  // }, [id, setValue]);

  useEffect(() => {
    if (!id || itemCategories.length === 0 || uoms.length === 0 || dataLoaded) return;

    setIsEdit(true);
    setEditId(id);

    const fetchItemById = async () => {
      setEditLoading(true);
      try {
        const res = await ItemService.getItemById(id);
        const record = res?.data || res;

        if (!record) {
          showMessage("Failed to load item details", "error");
          return;
        }

        setEditMode(true);

        setValue("itemCode", record.itemCode || "");
        setValue("itemDescription", record.itemDescription || "");
        setValue("itemCategoryId", record.itemCategoryId || "");
        setValue("uomId", record.uomId || "");

        setDataLoaded(true); // ✅ prevent re-run
      } catch (error) {
        console.error("Error fetching item:", error);
        showMessage("Error fetching item details", "error");
      } finally {
        setEditLoading(false);
      }
    };

    fetchItemById();
  }, [id, itemCategories, uoms, dataLoaded, setValue]);

  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify Item" : "Add Item"}
        secondTitle="Masters"
      ></Breadcrumb>

      {/* {message && (
        <div
          className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
            } d-flex justify-content-between align-items-center mb-3 p-2`}
        >
          <span>{message}</span>
          <button className="btn-close" onClick={closeMessage}></button>
        </div>
      )} */}
      
        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />
      

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {editLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <div className="mt-2 text-muted">Loading data...</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">
                    Item Name <span className="text-danger">*</span>
                  </label>
                  {/* <input
                    type="text"
                    className="form-control"
                    // {...register("itemCode", {
                    //   required: "Item Code is required",
                    //   // maxLength: { value: 45, message: "Max 45 characters" },
                    // })}

                    {...register("itemCode")}
                  /> */}
                  {/* {errors.itemCode && (
                    <small className="text-danger">{errors.itemCode.message}</small>
                  )} */}

                  <input
                      type="text"
                      className="form-control"
                      maxLength={50}
                      {...register("itemCode", {
                        required: "Item Name is required",
                        maxLength: {
                          value: 50,
                          message: "Max 50 characters",
                        },
                      })}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">
                    Item Description <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={2} // optional - better UX
                    // {...register("itemDescription", {
                    //   required: "Item Description is required",
                    //   maxLength: { value: 250, message: "Max 250 characters" }, // increased limit - optional suggestion
                    // })}

                    {...register("itemDescription")}
                  />
                  {/* {errors.itemDescription && (
                    <small className="text-danger">
                      {errors.itemDescription.message}
                    </small>
                  )} */}
                </div>



                {/* <div className="col-md-6">
                  <label className="form-label">
                    Item Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("itemName", {
                      required: "Item Name is required",
                      maxLength: { value: 45, message: "Max 45 characters" },
                    })}
                  />
                  {errors.itemName && (
                    <small className="text-danger">{errors.itemName.message}</small>
                  )}
                </div> */}
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">
                    Item Category <span className="text-danger">*</span>
                  </label>
                  <select className="form-select" {...register("itemCategoryId")}>
                    <option value="">Select Category</option>
                    {itemCategories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.itemCategoryName}
                      </option>
                    ))}
                  </select>

                  {/* {errors.itemCategoryId && (
                    <small className="text-danger">
                      {errors.itemCategoryId.message}
                    </small>
                  )} */}
                </div>
                {/* <div className="col-md-6">
                  <label className="form-label">Item Description</label>
                  <textarea
                    className="form-control"
                    {...register("itemDescription", {
                      required: "item Description is required",
                      maxLength: { value: 100, message: "Max 100 characters" },
                    })}
                  ></textarea>
                  {errors.itemDescription && (
                    <small className="text-danger">
                      {errors.itemDescription.message}
                    </small>
                  )}
                </div> */}

                <div className="col-md-6">
                  <label className="form-label">
                    UOM <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    // {...register("uomId", { required: "UOM is required" })}

                    {...register("uomId")}
                  >
                    <option value="">Select UOM</option>
                    {uoms.map((u) => (
                      <option key={u.id} value={u.id}>
                        {u.uomCode}
                      </option>
                    ))}
                  </select>
                  {/* {errors.uomId && (
                    <small className="text-danger">{errors.uomId.message}</small>
                  )} */}
                </div>
              </div>

              {/* <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">
                    UOM <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    {...register("uomId", { required: "UOM is required" })}
                  >
                    <option value="">Select UOM</option>
                    {uoms.map((u) => (
                      <option key={u.id} value={u.id}>
                        {u.uom}
                      </option>
                    ))}
                  </select>
                  {errors.uomId && (
                    <small className="text-danger">{errors.uomId.message}</small>
                  )}
                </div>
              </div> */}

              <button
                type="submit"
                className="btn btn-primary mt-3"
                disabled={loading}
              >
                <i className="ti ti-circle-check me-1"></i>
                {loading
                  ? isEdit
                    ? "Updating..."
                    : "Saving..."
                  : isEdit
                    ? "Update"
                    : "Save"}
              </button>
              <button
                type="button"
                className="btn btn-secondary mt-3 ms-2"
                disabled={loading}
                onClick={() => {
                  navigate("/cpnl/items/view");
                }}
              >
                <i className="ti ti-cancel me-1"></i>
                Cancel
              </button>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
